<div class="login-assistant-page-container">
  <div class="header-red">
    <span class="d-inline-block text-truncate header-text" id="group-name">{{groupName}}</span>
  </div>

  <div class="group-tile-container">
    <div id="group-list-container" class="tiles-wrapper">
      <au-tile *ngFor="let user of userTiles" [tile]="user" (onClick)="loginWithUser(user)"> </au-tile>
    </div>
  </div>
</div>
